// npm

// css
import '../../scss/pages/only-before2024.scss';

// libs

// utils

document.addEventListener('DOMContentLoaded', () => {});

window.addEventListener('load', () => {});
